import * as Types from '../../../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type FetchKarteOnUseKarteQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FetchKarteOnUseKarteQuery = { __typename?: 'Query', user: { __typename?: 'User', karte?: { __typename?: 'Karte', id: string, userComment: string, numberOfPlannerComments: number, hasCommentsFromPlannersBelongingToSameBranch: boolean, modifiedAt: TimeString, channel: Types.Channel, ownKartePlannerComment?: { __typename?: 'KartePlannerComment', comment?: string | null } | null, topics: Array<{ __typename?: 'KarteTopic', id: string, name: string }>, diagnosis: { __typename?: 'Diagnosis', gender: Types.Gender, livingPrefecture: Types.Prefecture, birthYear: number, saving: number, annualIncome: number, savingMonth: number, monthlyRentCost: number, monthlyInsurance: number, investment: number, loanBalance?: number | null, children: Array<{ __typename?: 'DiagnosisChild', age: number, gender: Types.Gender }>, partner?: { __typename?: 'DiagnosisPartner', birthYear: number, annualIncome: number } | null, job?: { __typename?: 'Job', name: string } | null } } | null } };


export const FetchKarteOnUseKarteDocument = gql`
    query FetchKarteOnUseKarte($id: ID!) {
  user(id: $id) {
    karte {
      id
      userComment
      ownKartePlannerComment {
        comment
      }
      numberOfPlannerComments
      topics {
        id
        name
      }
      hasCommentsFromPlannersBelongingToSameBranch
      modifiedAt
      channel
      diagnosis {
        gender
        livingPrefecture
        birthYear
        saving
        annualIncome
        savingMonth
        monthlyRentCost
        children {
          age
          gender
        }
        partner {
          birthYear
          annualIncome
        }
        monthlyInsurance
        investment
        job {
          name
        }
        loanBalance
      }
    }
  }
}
    `;

/**
 * __useFetchKarteOnUseKarteQuery__
 *
 * To run a query within a Vue component, call `useFetchKarteOnUseKarteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchKarteOnUseKarteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchKarteOnUseKarteQuery({
 *   id: // value for 'id'
 * });
 */
export function useFetchKarteOnUseKarteQuery(variables: FetchKarteOnUseKarteQueryVariables | VueCompositionApi.Ref<FetchKarteOnUseKarteQueryVariables> | ReactiveFunction<FetchKarteOnUseKarteQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>(FetchKarteOnUseKarteDocument, variables, options);
}
export function useFetchKarteOnUseKarteLazyQuery(variables?: FetchKarteOnUseKarteQueryVariables | VueCompositionApi.Ref<FetchKarteOnUseKarteQueryVariables> | ReactiveFunction<FetchKarteOnUseKarteQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>(FetchKarteOnUseKarteDocument, variables, options);
}
export type FetchKarteOnUseKarteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchKarteOnUseKarteQuery, FetchKarteOnUseKarteQueryVariables>;